import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ParkingPass } from 'models/parking-passes';
import { SCAN_CODE_METHOD } from 'models/validation';

class ScanCode extends React.Component {
  constructor(props) {
    super(props);
    const { usejs, parkingPass: { validation } } = props;
    this.state = {
      showPassCode: !usejs || !!validation.requiredMethods.get(SCAN_CODE_METHOD),
    };
    this.toggleScanCode = this.toggleScanCode.bind(this);
  }

  scanCodeText() {
    const scanCode = this.props.parkingPass.validation.scanCode.get('code');

    let scanCodeText;
    if (scanCode.length <= 20) {
      scanCodeText = (
        <p className="scan-code-text text-center text-color-dark-slate text-weight-medium with-vertical-margin-0-lte-sm">
          {scanCode}
        </p>
      );
    }

    return scanCodeText;
  }

  toggleScanCode() {
    this.setState({ showPassCode: !this.state.showPassCode });
  }

  isOptional() {
    const { parkingPass, usejs } = this.props;
    const { validation: { optionalMethods } } = parkingPass;
    return optionalMethods.get(SCAN_CODE_METHOD) && usejs;
  }

  render() {
    const { parkingPass } = this.props;
    const scanCodeClasses = cx({
      hidden: !this.state.showPassCode,
    });

    let toggleMessage;
    if (this.state.showPassCode) {
      toggleMessage = <FormattedMessage id="parking-pass.hide-scan" defaultMessage="Hide pass scan code" />;
    } else {
      toggleMessage = <FormattedMessage id="parking-pass.show-scan" defaultMessage="Show pass scan code" />;
    }
    
    return (
      <div>
        <div className={`scan-code force-show-print ${scanCodeClasses}`}>
          <img src={parkingPass.scanCodeURL} className="scan-code-image" alt="" />
          {this.scanCodeText()}
        </div>
        {this.isOptional() && <div className="text-center hidden-print scan-code-toggle">
          <a className="larger-hit-area text-color-dark-slate-lte-sm" style={{ color: `#${this.props.color}` }} onClick={this.toggleScanCode}>{toggleMessage}</a>
        </div>}
      </div>
    );
  }
}

ScanCode.propTypes = {
  color: PropTypes.string.isRequired,
  usejs: PropTypes.bool,
  parkingPass: PropTypes.instanceOf(ParkingPass).isRequired,
}

ScanCode.defaultProps = {
  usejs: true,
}

export default ScanCode;
